<template>
<div id="app">
	<div class="top-banner" :style="bannerImg?'background-image: url('+ bannerImg.value +');':''">
		<img @click="goUrl({name:'pageIndex'})" class="logo" src="./assets/img/logo.png" alt="">
	</div>
	<!-- <router-view  /> -->
	<transition name="fade">
		<router-view  />
	</transition>
</div>
</template>

<script>
export default {
	name: 'App',
	data(){
		return {
			bannerImg:null
		}
	},
	created() {
		this.getFriendLink()
		//获取浏览器宽高
		this.$store.commit('changeWindow',{winW:window.innerWidth,winH:window.innerHeight})
		window.onresize = () => {
			this.$store.commit('changeWindow',{winW:window.innerWidth,winH:window.innerHeight})
			var isMobile = this.$common.isMobile()
			this.$store.commit('changeIsMobile',isMobile)
		},
		
		this.getBanner('topBanner',1).then((list)=>{
			this.bannerImg = list[0]
		})
		
	},
	
	methods:{
		//获取友情链接
		getFriendLink(){
			this.$axios({
				url:'/index.php?s=common&c=api&m=getOutsideChain',
				success:(res)=>{
					this.$store.commit('changeFriendLink',res.data)
				}
			})
		},
		//获取广告banner图
		getBanner(space_code,limit){
			return new Promise((resolve,reject)=>{
				this.$axios({
					url:'/index.php?s=poster&c=api&m=getPosterList',
					params:{
						space_code:space_code	,//广告位编码 topBanner=顶部大图，indexBanner=中间轮播图，bottomBanner=底部滚动图
						limit:(limit?limit:10),		//限制条数
					},
					success:(res)=>{
						resolve(res.data)
					}
				})
			})
		},
	}
}
</script>

<style lang="less">
@import '~@/assets/css/reset.less';
@import '~@/assets/css/common.less';
</style>



// WEBPACK FOOTER //
// src/App.vue